import mblockFullData from '../mock/mblock-full-data'
import { addAsset } from '../lib/xes/xes-lib'
const mblock = {
  loadProjectByJson(xml) {
    if (window.mblock)
    window.mblock.project.renderFromData(xml, (res) => {
      console.log('success', res)
      let loading = document.getElementById('loading-wrapper')
      if (loading) document.body.removeChild(loading)
      // window.mblock.setLang('zh')
    }, (res) => {
      // mblock.loadProjectByJson(xml)
      console.log('fail', res)
    })
  },
  addWebStore(getFunc, createFunc, updateFunc) {
    if (window.mblock) {
      window.mblock.scratch.prependWebStore(getFunc, createFunc, updateFunc)
    }
  },
  reset() {
    if (window.mblock)
    window.mblock.project.reset()
  },
  upload(cb) {
    if (window.mblock)
    window.mblock.project.import(cb)
  },
  download(name) {
    if (window.mblock)
    window.mblock.project.export({name})
  },
  async download_app() {
    if (window.mblock)
      return await window.mblock.project.exportToBlob();
  },
  getCode() {
    let jsonStr = window.mblock.project.exportToJsonString()
    return jsonStr
    return JSON.stringify(JSON.parse(jsonStr)['vmJson'])
  },
  getCover() {
    return window.mblock.project.getCover()
  },
  init() {
    this.onAssetsLoaded((asset) => addAsset(asset.assetId))
    this.onProjectLoad(() => {
      window.mblock.setLang('zh')
    })
  },
  getAssets() {
    return window.mblock.scratch.getAssets()
  },
  onProjectLoad(cb) {
    if (window.mblock)
    window.mblock.project.onLoadingProject((complete, total) => {
      if (complete === total) {
        cb()
      }
    })
  },
  onAssetsLoaded(cb) {
    if (window.mblock)
    window.mblock.sprite.onAssetLoaded((asset) => {
      cb(asset)
    })
  },
  // 项目加载完成的回调
  onLoadedProject(cb) {
    if (window.mblock)
    window.mblock.project.onLoadedProject((projectInfo) => {
      cb(projectInfo)
    })
  }
}

// mblock.init()
export {
  mblock as default,
}